export function useFormattedPrice(price) {
    const currentDate = new Date();
    const julyFirst = new Date(currentDate.getFullYear(), 6, 1);

    if (currentDate >= julyFirst) {
        price = price === 30000 ? 50000 : price === 18000 ? 30000 : price;
    }

    return price.toLocaleString('ru-RU');
}